import type {MetropolisConfiguration} from '@nlabs/metropolisjs';

export const SENTINEL_ANALYTICS_ID = '55985374-1d73-4447-aefd-e4e53c9ab610';

export const createMetropolisConfig = (publicEndpoint: string): MetropolisConfiguration => {
  const environment = {
    app: {
      api: {
        endpoints: {rum: publicEndpoint},
        public: publicEndpoint,
        rum: publicEndpoint
      },
      name: 'chicago-sentinel-times',
      rum: {
        analyticsId: SENTINEL_ANALYTICS_ID,
        enabled: true,
        respectPrivacySignals: true
      }
    }
  } as const;

  return {
    development: environment,
    local: environment,
    production: environment,
    test: environment
  };
};
